import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../lib/api';
import { getCurrencyByCountryCode } from '../../lib/countries';

const initialState = {
  sender: {
    name: 'USD',
    rate: 1,
    symbol: '$',
  },
  receiver: {
    name: '',
    rate: 1,
    symbol: '',
  },
};

export const fetchCurrencies = createAsyncThunk(
  'currencies/fetchCurrencies',
  async (_, { getState }) => {
    const { countryCode } = getState().receiver;
    const currency = getCurrencyByCountryCode(countryCode);

    const receiverResponse = await api.getConversionRate(currency);

    const receiver = {
      name: receiverResponse.conversionRate.currencyTo,
      rate: receiverResponse.conversionRate.rate,
      symbol: receiverResponse.conversionRate.symbolTo,
    };

    const senderInfo = await api.getUserLocationInfoExt();

    const senderCurrency = getCurrencyByCountryCode(senderInfo.countryCode);
    const senderResponse = await api.getConversionRate(senderCurrency);

    const sender = {
      name: senderResponse.conversionRate.currencyTo,
      rate: senderResponse.conversionRate.rate,
      symbol: senderResponse.conversionRate.symbolTo,
    };

    return { receiver, sender };
  }
);

const currenciesSlice = createSlice({
  name: 'currencies',
  initialState,
  reducers: {
    setPaymentMethods(state, action) {
      state.currencies = action.payload;
    },

    selectPaymentMethod(state, action) {
      state.selected = action.payload;
    },
  },
  extraReducers: {
    [fetchCurrencies.fulfilled]: (state, action) => {
      state.receiver = action.payload.receiver;
      state.sender = action.payload.sender;
    },
  },
});

export default currenciesSlice.reducer;
